module.exports = __webpack_public_path__ + "static/media/loading.5fe0e55f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = 250
// module chunks = 52